import React, {
  Suspense, useContext, useEffect, useState,
} from 'react';
import { ChatBotOpenContext } from './ChatBotOpenContext';

// Defer loading the ChatBot bundle (react-markdown, remark-gfm, workflow icons, etc.)
// until the user first opens the chat. This keeps that code out of the initial
// page load. Once mounted, we keep it mounted so conversation state survives the
// drawer being closed and reopened.
const ChatBot = React.lazy(() => import('./ChatBot'));

function DeferredChatBot(props) {
  const ctx = useContext(ChatBotOpenContext);
  const isOpen = ctx?.isOpen ?? false;
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (isOpen) setShouldMount(true);
  }, [isOpen]);

  if (!shouldMount) return null;

  return (
    <Suspense fallback={null}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ChatBot {...props} />
    </Suspense>
  );
}

export default DeferredChatBot;
